module.exports = __webpack_public_path__ + "img/2_floor.74d01355.png";